var _path, _path2, _circle, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpertise(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 70,
    viewBox: "0 0 59 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0936 46.7321V67.2385L35.8476 67.8239V57.2778H43.6107C46.5401 57.2778 49.7626 53.9089 49.7626 51.1259V42.9234C50.4461 42.8746 52.2819 42.8063 54.1568 42.9234C56.5003 43.0699 56.6468 41.8981 56.6468 39.5545C56.6468 37.6797 51.7644 31.5473 49.3231 28.7155C49.1767 27.202 48.9716 23.296 49.3231 19.7806C48.8837 17.1441 41.267 2.49691 23.9832 2.35044C6.69931 2.20396 0.840335 21.5385 1.86565 31.6452C2.6859 39.7305 8.35942 45.072 11.0936 46.7321Z",
    stroke: "#0077A0",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1784 22.0485L21.3649 22.128L21.4443 18.5527L18.6636 16.0104L21.5238 14.3419L21.3649 10.29L24.3839 10.4489L27.1647 6.95312L29.8659 10.1311L33.8384 9.9722L33.9973 14.7392L36.6191 15.772L34.0768 18.2349L33.9973 20.6184L33.9179 23.0019L30.8988 22.3663L27.6414 25.0676L25.1784 22.0485Z",
    stroke: "#0077A0",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9692,
    cy: 33.0581,
    r: 2.9502,
    stroke: "#0077A0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 27.4956,
    cy: 16.2617,
    r: 2.9502,
    stroke: "#0077A0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpertise);
export default __webpack_public_path__ + "static/media/expertise.8b5148029299b67f4fc0f8bbeb88766a.svg";
export { ForwardRef as ReactComponent };